import { render, staticRenderFns } from "./ClubbingCard.vue?vue&type=template&id=352a4cfe&scoped=true&"
import script from "./ClubbingCard.vue?vue&type=script&lang=js&"
export * from "./ClubbingCard.vue?vue&type=script&lang=js&"
import style0 from "./ClubbingCard.vue?vue&type=style&index=0&id=352a4cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352a4cfe",
  null
  
)

export default component.exports